var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpscout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210px",
    height: "212px",
    viewBox: "0 0 210 212",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Help Scout logo square") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.6390913,39.3226496 L8.37111885,78.6452973 C3.58762441,73.7299657 0.597939295,66.9713832 3.55271368e-15,58.9839747 C3.55271368e-15,51.6109741 3.58762297,44.2379788 8.37111885,39.3226496 L47.2370253,0 C52.0205227,4.91533064 55.0102078,12.2883274 55.0102078,19.661324 C55.0102078,27.0343223 51.4225887,34.4073175 46.6390913,39.3226496 Z M63.4733142,93.7693871 L102.161809,54.4467443 C106.997878,59.9764888 110.020417,66.7350709 110.020417,74.1080774 C110.020417,81.4810721 106.393368,88.8540669 101.55731,93.7693988 L62.8688094,133.092042 C58.0327467,128.176704 55.0102078,120.803715 55.0102078,113.430714 C55.0102078,106.057714 58.6372508,98.6847128 63.4733142,93.7693871 Z M62.5252575,39.322639 L73.9481456,27.8283265 L102.204765,0 C107.014396,4.83970997 110.020418,12.0992757 110.020418,19.3588415 C110.020418,26.6184087 106.413189,33.8779731 101.603558,38.7176845 L73.9481511,66.5460181 L62.5252629,78.0403331 L46.2927439,94.3743548 L34.8698564,105.868664 L7.81565611,133.092035 C3.00602225,128.252317 -1.42108547e-14,120.992759 -1.42108547e-14,113.733189 C-1.42108547e-14,106.473619 3.60722754,99.2140488 8.41686291,94.3743433 L35.4710632,67.1509728 L46.2927385,55.6566626 L62.5252575,39.322639 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visual-Elements-/-Logos",
    transform: "translate(-658.000000, -2033.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help-Scout-logo-square",
    transform: "translate(658.000000, 2033.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors/_Default/White",
    transform: "translate(0.000000, 0.991224)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Swatch",
    x: 0,
    y: 0,
    width: 210,
    height: 210
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logos/1.-Help-Scout/Mark",
    transform: "translate(51.000000, 37.994346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color-Mask"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Blue/500",
    mask: "url(#mask-2)",
    fill: "#1292EE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Swatch",
    x: 0,
    y: 0,
    width: 109.966158,
    height: 132.959082
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E5E9EC",
    x: 0.5,
    y: 1.49122428,
    width: 209,
    height: 209.01772
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpscout);
export default __webpack_public_path__ + "static/media/helpscout.d420801d0a0f3aa054c5aa3575bb0077.svg";
export { ForwardRef as ReactComponent };